import React from 'react';
import {Input, Select, Form, Modal, DatePicker} from 'antd';
import moment from 'moment';



const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
}


const modalMaster = ({visible,item = {},onCancel,form: {getFieldDecorator,validateFields,getFieldsValue,
	},}) => {
	function handleOk () {

				onCancel()

	}
	console.log(item)

	const modalOpts = {
	  title: '授信额度',
	  visible,
	  onCancel,
	  keyboard:false,
	  maskClosable:false,
	  wrapClassName: 'vertical-center-modal',
	  width: 520,
		onOk: handleOk,
		// onOk
	  //okText: '确认',
      //cancelText: '取消',
	}



	return (
	  <Modal {...modalOpts}>
		<Form layout="horizontal">

		{/*<Form.Item label={'客户名称'} {...formItemLayout} >
			{getFieldDecorator('custName', {
					initialValue: item.custName,
				}
			)(
				<Input disabled/>
			)}
		</Form.Item>
		<Form.Item label={'已使用额度'} {...formItemLayout} >
		   {getFieldDecorator('usedLimit', {
				initialValue: item.usedLimit,
			  }
			)(
			<Input disabled/>
			)}
		</Form.Item>
		<Form.Item label={'可用额度'} {...formItemLayout} >
		   {getFieldDecorator('usableLimit', {
				initialValue: item.usableLimit,
			  }
			)(
			   <Input disabled/>
			)}
		</Form.Item>*/}
		<Form.Item label={'最新授信总额度'} {...formItemLayout} >
		   {getFieldDecorator('creditLimit', {
				initialValue: item.creditLimit,
			  }
			)(
			   <Input  disabled/>
			)}
		</Form.Item>
		{/*<Form.Item label={'授信额度状态'} {...formItemLayout} >
		   {getFieldDecorator('statusDesc', {
				initialValue: item.statusDesc,
			  }
			)(
			   <Input disabled/>
			)}
		</Form.Item>
		<Form.Item label={'生效日期'} {...formItemLayout} >
		   {getFieldDecorator('effectiveDate', {
				initialValue: item.effectiveDate,
			  }
			)(
			   <Input disabled/>
			)}
		</Form.Item>
		<Form.Item label={'失效日期'} {...formItemLayout} >
			{getFieldDecorator('expiredDate', {
					initialValue: item.expiredDate,
				}
			)(
				<Input disabled/>
			)}
		</Form.Item>*/}
		</Form>
	  </Modal>
	)
}


const ModalLimitInfo = Form.create()(modalMaster);


export default ModalLimitInfo;
